import React from 'react';
import { Helmet } from "react-helmet";
import dayjs from 'dayjs';


var META = {
    url: "https://whoishiring.io",
    title: "Who is Hiring?",
    image: "https://whoishiring.io/images/logos/logo.png",
    description: {
        short: "The map with the collection of jobs for Software Engineers, Developers",
        long: "The map with the collection of jobs for Software Engineers, Software developers, Programmers, Designers and remote. Aggregator of job post from Hacker News, Stack Overflow, Github, and many more ..."
    }
};

export const IndexMetaInfo = () => {
    
    const JSONLD = {
        organization: {
            "@context": "http://schema.org",
            "@type": "Organization",
            "name": "whoishiring.io",
            "url": "https://whoishiring.io",
            "logo": "https://whoishiring.io/images/logos/logo.png",
            "sameAs": [
                "https://www.facebook.com/whoishiringio/",
                "https://twitter.com/whoishiringio",
                "https://www.linkedin.com/company/whoishiring.io",
                "https://www.producthunt.com/posts/whoishiring-io"
            ]
        },
        website: {
            "@context": "http://schema.org",
            "@type": "WebSite",
            "name": "whoishiring.io",
            "url": "https://whoishiring.io",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://whoishiring.io/search/23.3389/-31.9480/2?search={search_term_string}",
                "query-input": "required name=search_term_string"
            }
        }
    }


    return (
        <Helmet titleTemplate="whoishiring.io - %s" defaultTitle={META.title}>

            <title>{META.title}</title>

            <meta name="description" content={META.description.long} />
            
            <script type="application/ld+json">{JSON.stringify(JSONLD.organization)}</script>
            <script type="application/ld+json">{JSON.stringify(JSONLD.website)}</script>

            <meta name="og:image" content={META.image} />
            <meta name="og:url" content={META.url} />
            <meta name="og:title" content={META.title} />
            <meta name="og:description" content={META.description.short} />

            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@whoishiringio" />
            <meta name="twitter:url" content={META.url} />
            <meta name="twitter:title" content={META.title} />
            <meta name="twitter:description" content={META.description.short} />

        </Helmet>
    )
}

export const AboutMetaInfo = () => {
    return (
        <Helmet>
            <title>About</title>
            
            <meta name="description" content="About the whoisiring.io project" />
        </Helmet>
    )
}

export const ItemMetaInfo = (props) => {
    
    const { item } = props;
    
    const title = item.company ? `${item.title} @ ${item.company}` : item.title;
    const url = `https://whoishiring.io/s/${item.id}`;
    
    const description = item.description.replace(/<\/?[^>]+(>|$)/g, "");

    const JSONLD = {
        "@context": "http://schema.org/",
        "@type": "JobPosting",
        "title": item.title,
        "image": item.logo,
        "description": description,
        "datePosted": dayjs(item.time).format(),
        "employmentType": item.kind,
        "occupationalCategory": item.category.name,
        "url": url,
        "jobLocation": {
            "@type": "Place",
            "address": {
                "@type": "PostalAddress",
                "addressLocality": item.address, 
                "addressRegion": item.address
            }
        },
        "hiringOrganization": {
            "@type": "Organization",
            "name": item.company,
            "address": item.address,
            "sameAs": "", // fill
            "logo": ""  // fill
        }
    }
    
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description.substring(0, 300)} />
                        
            <meta name="og:image" content={item.logo} />
            <meta name="og:url" content={url} />
            <meta name="og:title" content={title} />

            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@whoishiringio" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={title} />
            
            <script type="application/ld+json">{JSON.stringify(JSONLD)}</script>
        </Helmet>
    )
}

